import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import Dashboard from './Dashboard'
import GamesTable from './GamesTable'
import Header from './Header'

import { Container, Divider } from 'semantic-ui-react'

import { useMeleeContext } from '../../draft/context/MeleeContextProvider'

import { GetFormattedDate } from '../utils/Common'

const TournamentIndex = () => {
    const [showCompletedGames, setShowCompletedGames] = useState(true);

    const navigate = useNavigate();
    const location = useLocation();

    const meleeContext = useMeleeContext();

    useEffect(() => {
        const tournamentId = location.pathname.split('/')[2];
        const jsonTour = localStorage.getItem('Tournament#' + tournamentId);
        if (!jsonTour) {
            navigate("/create")
        }
        if (meleeContext)
            meleeContext.setTournament(JSON.parse(jsonTour + ''));
    }, [location.pathname, navigate, meleeContext])

    if (!meleeContext) return <></>;

    const currentTournament = meleeContext.tournament;

    document.title = `${currentTournament.Name}`

    return (
        <div className='melee-wrapper'>
            <Container>
                <Header
                    name={`${currentTournament.Name ? currentTournament.Name : currentTournament.Id}`}
                    date={currentTournament.CreatedAt ? GetFormattedDate(currentTournament.CreatedAt) : ''}
                />

                <Dashboard
                    showCompletedGames={showCompletedGames}
                    setShowCompletedGames={setShowCompletedGames}
                />

                <Divider horizontal style={{ color: 'white' }}>Games</Divider>

                <GamesTable
                    showCompletedGames={showCompletedGames}
                    games={currentTournament.GroupStageGames}
                    tournamnet={currentTournament}
                />
            </Container>
            
        </div>
    )
}


export default TournamentIndex;